//store
import store from "../../Redux/store";
//base communication
import BaseCommunication from "../../Communication/BaseCommunication";
//constants
import { 
    CREATE_REPORT_ACTION, 
    LOCATION_ACTION, 
    HOME_ACTION, 
    SUMMERY_ACTION,
    SELF_SUMMARY_ACTION, 
    SUMMERY_UPDATE_ACTION, 
    HISTORY_ACTION,
    GET_INVITATION_INFO_ACTION, 
    GET_REPORT_ACTION, 
    DELETE_REPORT_ACTION,
    REMOVE_CONNECTION_ACTION,
    GET_CONFIG_ACTION,    
} from "./Constants";
import { API_URL, API_BASE_URL, HttpMethod, OperationStatus, } from "../../Communication/Constants";

export default class DashBordAction extends BaseCommunication {
    getList(requestData, callback) {
        this.callAPI(HOME_ACTION, API_BASE_URL + API_URL.BASE_USER_URL + requestData.userid + API_URL.USER_MONITOR_MAPPING+'?rnd='+Date.now(), HttpMethod.GET, {},
            (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    if (apiResponse.data !== null) {
                        store.dispatch({
                            type: HOME_ACTION,
                            response: apiResponse.data.data,
                        });
                    }
                }
                callback(apiResponse);
            }
        );
    }
    getSummeryData(requestData, callback) {
        let url = API_BASE_URL + API_URL.BASE_USER_URL + requestData.loggedInUserId + API_URL.SUMMARY;
        if (requestData.addUserIdInRequest) {
            url = API_BASE_URL + API_URL.BASE_USER_URL + requestData.loggedInUserId + API_URL.SUMMARY + "?for_user_id=" + requestData.for_userid;
            if (requestData.forDate) {
                url = url + "&for_date=" + requestData.forDate;
            }
        }
        
        this.callAPI(SUMMERY_ACTION, url, HttpMethod.GET, {}, (apiResponse) => {
            if (apiResponse.status === OperationStatus.SUCCESS) {
                if (apiResponse.data.data != null) {
                    if (!requestData.actionFlag) {
                        store.dispatch({
                            type: SUMMERY_ACTION,
                            response: apiResponse.data.data,
                        });
                    } else {
                        store.dispatch({
                            type: SUMMERY_UPDATE_ACTION,
                            response: apiResponse.data.data,
                        });
                    }
                }
            }
            if (apiResponse.error) callback(apiResponse);
        });
    }
    getSelfSummaryData(requestData, callback) {
        let url = "";
        if (requestData.addUserIdInRequest) {
            url = API_BASE_URL + API_URL.BASE_USER_URL + requestData.loggedInUserId + API_URL.SUMMARY + "?for_user_id=" + requestData.for_userid;
            if (requestData.forDate) {
                url = url + "&for_date=" + requestData.forDate;
            }
        }
        
        this.callAPI(SELF_SUMMARY_ACTION, url, HttpMethod.GET, {}, (apiResponse) => {
            if (apiResponse.status === OperationStatus.SUCCESS) {
                if (apiResponse.data.data != null) {
                    store.dispatch({
                        type: SELF_SUMMARY_ACTION,
                        response: apiResponse.data.data,
                    });
                }
            }
            if (apiResponse.error) callback(apiResponse);
        });
    }
    //history data / graph data
    getHistoryData(requestData, callback) {
        let url = API_BASE_URL + API_URL.BASE_USER_URL + requestData.loggedInUserId + API_URL.HISTORY + "?for_user_id=" + requestData.forUserId + "&interval="
            + requestData.interval + "&start=" + requestData.start + "&parameter_id=" + requestData.paramId + "&parameter_name=" + requestData.paramName;
        if (requestData.end) {
            url = url + "&end=" + requestData.end
        }
        this.callAPI(HISTORY_ACTION, url, HttpMethod.GET, {}, (apiResponse) => {
            if (apiResponse.status === OperationStatus.SUCCESS) {
                if (apiResponse.data.data != null) {
                    store.dispatch({
                        type: HISTORY_ACTION,
                        response: apiResponse.data.data,
                    });

                }
            }
            callback(apiResponse);
        });
    }

    getInvitationInfo(callback) {
		this.callAPI(GET_INVITATION_INFO_ACTION, API_BASE_URL + API_URL.BASE_USER_URL + API_URL.GET_INVITATION_INFO, HttpMethod.GET, {},
			(apiResponse) => {
				if (apiResponse.status === OperationStatus.SUCCESS) {
					if (apiResponse.data !== null) {
						store.dispatch({
							type: GET_INVITATION_INFO_ACTION,
							response: apiResponse.data.data,
						});
					}
				}
				callback(apiResponse);
			}
		);
    }
    
    getLocation(requestData, callback) {
        this.callAPI(LOCATION_ACTION, API_BASE_URL + API_URL.BASE_USER_URL + API_URL.LOCATION, HttpMethod.POST, requestData,
            (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    if (apiResponse.data !== null) {
                        store.dispatch({
                            type: LOCATION_ACTION,
                            response: apiResponse.data,
                        });
                    }
                }
                callback(apiResponse);
            }
        );

        
    }
    createReport(requestData, callback) {
        this.callAPI(CREATE_REPORT_ACTION, API_BASE_URL + API_URL.REPORTS, HttpMethod.POST, requestData,
            (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    if (apiResponse.data !== null) {
                        store.dispatch({
                            type: CREATE_REPORT_ACTION,
                            response: apiResponse.data,
                        });
                    }
                }
                callback(apiResponse);
            }
        );

        
    }
    getReports(requestData, callback) {
        let url = API_BASE_URL + API_URL.REPORTS + "?report_of=" + requestData.id
        this.callAPI(GET_REPORT_ACTION, url, HttpMethod.GET, requestData,
            (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    if (apiResponse.data !== null) {
                        store.dispatch({
                            type: GET_REPORT_ACTION,
                            recipients: apiResponse.data.data.reports.recipients
                        })
                    }
                }
                callback(apiResponse)
            }
        )
    }
    deleteReport(requestData, callback) {
        this.callAPI(DELETE_REPORT_ACTION, API_BASE_URL + API_URL.REPORTS, HttpMethod.DELETE, requestData,
            (apiResponse) => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    store.dispatch({
                        type: DELETE_REPORT_ACTION,
                        id: requestData.report_recipient_id
                    })
                }
                callback(apiResponse)
            })
    }
    removeConnectionAction(requestData, callback) {
		let url = API_BASE_URL + API_URL.BASE_USER_URL + API_URL.LIST_MONITORED_MONITORING_USERS + "/" + (requestData.connection_id) + API_URL.REMOVE
		this.callAPI(
			REMOVE_CONNECTION_ACTION,
			url,
			HttpMethod.POST,
			requestData,
			apiResponse => {
				if (apiResponse.status === OperationStatus.SUCCESS) {
					store.dispatch({
						type: REMOVE_CONNECTION_ACTION,
						deletedId: requestData.connection_id
					})
				}
				callback(apiResponse)
			}
		)
	}
    getUserConfig(requestData, callback) {
        let url = API_BASE_URL + API_URL.BASE_USER_URL + API_URL.CONFIG
        this.callAPI(
            GET_CONFIG_ACTION,
            url,
            HttpMethod.GET,
            requestData,
            apiResponse => {
                if (apiResponse.status === OperationStatus.SUCCESS) {
                    store.dispatch({
                        type: GET_CONFIG_ACTION,
                        response: apiResponse.data,
                    });
                }
                callback(apiResponse);
            }
        )
    }


}